<template>
  <div class="absolute bg-block opacity-50 -inset-8 z-100"
       v-if="$store.state.cabinet.passwordGuard.active"></div>
</template>

<script>
export default {
  name: "PasswordGuardOverlay",
}
</script>